module.exports = __webpack_public_path__ + "356d3e40dc7fcd08d5a352897acb67b0.svg";